import ProductPage from "../components/ProductPage";
import { IMAGES } from "../lib/site";

const config = {
  slug: "bbq-coconut-charcoal",
  label: "PRODUCT 02",
  category: "BBQ Charcoal",
  h1: "Coconut Shell BBQ Charcoal Briquettes",
  tagline: "Long-burning coconut shell charcoal briquettes for BBQ and grilling — export-ready from Indonesia.",
  specificationNote: "Final specifications are confirmed according to the applicable production batch and COA.",
  burningTimeNote: "Reference burning time. Actual performance may vary according to product size, airflow, application and batch specification.",
  subheading: "Export-ready BBQ charcoal sourced from selected Indonesian manufacturing partners.",
  description:
    "Coconut shell charcoal briquettes for BBQ, grilling, wholesale distribution and food-service applications — sourced from selected Indonesian manufacturing partners and prepared for export.",
  quoteProduct: "BBQ Coconut Charcoal Briquettes",
  heroImage: IMAGES.variantBbqHexFlower,
  heroAlt: "Hexagonal flower coconut shell BBQ charcoal briquette with a central hole",
  keySpecs: [
    { label: "Shape / Size", value: "Hexagonal Flower 5.0×5.0×9.0 cm" },
    { label: "Fixed Carbon", value: "≥ 80%" },
    { label: "Ash Content", value: "1.9–2.5%" },
    { label: "Moisture", value: "Max 6%" },
    { label: "Burning Time", value: "60–120 min" },
  ],
  overview: [
    "HAQILA supplies coconut shell BBQ charcoal briquettes from Indonesia for grilling, restaurants and food-service buyers. Production is carried out by selected Indonesian manufacturing partners, with HAQILA coordinating sourcing and export.",
    "Launching with 2 core shapes — Cube with a ridged edge detail and Hexagonal Flower with Hole — suited for wholesale distribution, food-service and retail programs. Final specifications are confirmed per batch COA before order confirmation.",
    "Wholesale BBQ charcoal and private label BBQ charcoal options can be discussed for importers and distributors. Bulk supply is quoted according to the agreed specification, packaging, order volume and destination.",
  ],
  applications: [
    "BBQ and grilling distributors",
    "Wholesale and trading companies",
    "Food-service and hospitality supply",
    "Private-label retail programs",
  ],
  specs: [
    ["Raw Material", "Coconut shell charcoal"],
    ["Application", "BBQ, grilling, food-service"],
    ["Shape", "Cube (Ridged Edge), Hexagonal Flower with Hole"],
    ["Ash Color", "White ash"],
    ["Fixed Carbon", "≥ 80%"],
    ["Moisture", "≤ 6%"],
    ["Ash Content", "1.9 – 2.5%"],
    ["Burning Time", "60 – 120 minutes"],
    ["Packaging", "Bulk / custom"],
    ["Loading Capacity", "± 18 MT per 20FT / ± 26 MT per 40FT"],
  ],
  shapes: ["Cube (Ridged Edge)", "Hexagonal Flower with Hole"],
  sizeOptions: [
    { name: "Cube (Ridged Edge)", size: "4.0 × 4.0 × 7.0 cm", image: IMAGES.variantBbqCubeRidged, alt: "Ridged-edge coconut shell BBQ charcoal briquette" },
    { name: "Hexagonal Flower with Hole", size: "5.0 × 5.0 × 9.0 cm", image: IMAGES.variantBbqHexFlower, alt: "Hexagonal flower BBQ coconut charcoal briquette for grilling" },
  ],
  packaging: [
    { size: "10 KG", copy: "Standard bulk carton for wholesale and distribution channels." },
    { size: "Bulk", copy: "Bulk packaging configurations for container-load orders." },
    { size: "Custom / Private Label", copy: "Custom and branded packaging can be discussed per order and quantity." },
  ],
  gallery: [
    { src: IMAGES.charcoalDetail, caption: "Product of Indonesian Manufacturing Partners", alt: "Glowing coconut shell BBQ charcoal briquettes for grilling" },
    { src: IMAGES.charcoalClose, caption: "Product Close-Up", alt: "Close-up of coconut shell charcoal briquettes" },
    { src: IMAGES.charcoalHero, caption: "Briquette Detail", alt: "Coconut shell charcoal briquettes showing cube shape and surface texture" },
    { src: IMAGES.coconutShell, caption: "Raw Material — Coconut Shell", alt: "Raw coconut shells used for charcoal production" },
    { src: IMAGES.coconutShellAlt, caption: "Sourcing at Origin", alt: "Charcoal handling at an Indonesian manufacturing partner facility" },
    { src: IMAGES.logistics, caption: "Export Logistics — Indonesia", alt: "Warehouse handling and container loading for export" },
    { src: IMAGES.packagingBox, caption: "1KG Retail Box", alt: "1 kg coconut charcoal briquette retail packaging" },
  ],
};

export default function BbqCharcoal() {
  return <ProductPage config={config} />;
}
